import React from "react";
import "./ConfirmModal.css";

// In-app replacement for window.confirm/window.alert. While `loading` is true the
// modal can't be dismissed — the action is in flight and the caller decides when
// to close (after its request resolves). Pass `error` to surface a failure inside
// the modal instead of a browser-native alert.
function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  loading = false,
  loadingLabel = "Working...",
  error = "",
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  const lines = Array.isArray(message) ? message : [message];

  return (
    <div className="cm-overlay" onClick={() => !loading && onCancel()}>
      <div className="cm-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        {title && <h3 className="cm-title">{title}</h3>}
        <div className="cm-message">
          {lines.map((line, i) => (line === "" ? <br key={i} /> : <p key={i}>{line}</p>))}
        </div>
        {error && <div className="cm-error">{error}</div>}
        <div className="cm-buttons">
          <button type="button" className="cm-btn-cancel" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={danger ? "cm-btn-confirm cm-btn-danger" : "cm-btn-confirm"}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading && <span className="cm-spinner" aria-hidden="true" />}
            {loading ? loadingLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
